import { useEffect, useState } from "react";
import { useAuth } from "../utils/AuthContext";

export const usePharmacist = () => {
  const { user, loading } = useAuth();
  const [isPharmacist, setIsPharmacist] = useState(false);
  const [pharmacistLoading, setPharmacistLoading] = useState(true);
   const [isAdmin, setIsAdmin] = useState(false);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);

  useEffect(() => {
    if (!loading) { // AuthContext এর লোডিং শেষ হলেই চেক করুন
      if (user) {
        setIsPharmacist(user.role === "pharmacist");
         setIsAdmin(user.role === "admin");
      setIsSuperAdmin(user.role === "superadmin");
        
      } else {
        setIsPharmacist(false);
        setIsAdmin(false);
      setIsSuperAdmin(false);
        
      }
      setPharmacistLoading(false);
    }
  }, [user, loading]);

  return { isPharmacist,isAdmin, isSuperAdmin, isLoading: loading || pharmacistLoading };
};